import { css } from "lit";

export const createFeedbackModalStyles = css`
  .subtitle {
    text-align: center;
    padding-bottom: var(--sds-size-space-800);
  }

  .thumbs-wrapper {
    display: flex;
    justify-content: center;
    gap: var(--sds-size-space-400);
  }
`;
